<template>
  <h3>Photos</h3>
  <component :is="page" v-if="$route.name" />
</template>

<script setup>
import {useRoute} from "vue-router";
const route = useRoute();
import {shallowRef} from "vue";
let page = shallowRef();
try {
  if (route.params.year) {
    let year = route.params.year;
    page = shallowRef(require(`@/assets/years/${year}/Photos/Index.vue`).default);
  }
} catch (error) {
  console.error(`Photos.vue|${route.params.year} error: ${error}`);
}
</script>
